import React, { Component, PropTypes } from 'react';

import { NitroHeading, NitroButtonGroup, NitroButton, NitroDivider, NitroDrawer } from 'nitro-components';

import {SingleSelect} from '../../../components/filter';

class ExportDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: ''
    };
  }

  handleOptionSelect = option => {
    this.setState({
      type: option.value
    });
  };

  exportData = () => {
    const { type } = this.state;

    if (type === 'csv') {
      this.props.exportCSV();
    } else {
      this.props.exportChart({
        type
      });
    }
    this.props.close();
  };

  render() {
  
    const { open, close } = this.props;

    const { type } = this.state;
     
    var  options= [   { id:'csv', label: 'CSV', value: 'csv'},
    { id:'pdf', label: 'PDF', value: 'application/pdf'},
    { id:'jpeg', label: 'Image', value: 'image/jpeg'}
  ];
    if(this.props.exportType=='Table')
    {
      options= [   { id:'csv', label: 'CSV', value: 'csv'},
      { id:'pdf', label: 'PDF', value: 'application/pdf',  disabled:'true' },
      { id:'jpeg', label: 'Image', value: 'image/jpeg', disabled:'true'}
    ];
  };

    let availableOptions=[];

    if(this.props.availableOptions) {
       availableOptions=options.filter((opt)=>{
        return this.props.availableOptions.indexOf(opt.id)>=0;
      });
    }
    else {
      availableOptions = options;
    }

    return (
      <NitroDrawer isOpen={open} close={close} staticFooter action={this.exportData} actionLabel="Export Data">

        <NitroHeading size="2" variant="secondary" label="Export" />

        <section>
          <NitroHeading size="3" label="Select file format..." />

          <SingleSelect action={this.handleOptionSelect} filter={{
            value: type,
            options:availableOptions,
           
          }} />

        </section>

        <NitroDivider />

        {/* <NitroButtonGroup align="right">
          <NitroButton action={this.exportData} size="small" label="Export data" variant="secondary" />
        </NitroButtonGroup> */}

      </NitroDrawer>
    );
  }
}

ExportDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  exportCSV: PropTypes.func.isRequired,
  exportChart: PropTypes.func.isRequired,
  availableOptions:PropTypes.array
};

export default ExportDrawer;



// WEBPACK FOOTER //
// ./src/features/insights/components/ExportDrawer.js